import React, { memo, useRef, useState } from 'react';
import trash from '@/assets/images/trash.svg';
import css from './table.module.css';

interface IProps {
  field: string;
  onChangeName: React.Dispatch<
    React.SetStateAction<
      {
        field: string;
      }[]
    >
  >;
}

export const TableHeader = memo<IProps>(({ field, onChangeName }) => {
  const [isInput, setIsInput] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleInput = () => {
    setIsInput(true);
  };

  const handleBlur = () => {
    setIsInput(false);
    onChangeName((prev) => {
      const index = prev.findIndex((item) => item.field === field);
      const newHeaderCols = [...prev];
      newHeaderCols[index] = { field: inputRef.current?.value || field };
      // save to local storage
      localStorage.setItem('headerCols', JSON.stringify(newHeaderCols));
      return newHeaderCols;
    });
  };

  const handleReset = () => {
    if (window.confirm('Are you sure you want to reset the table?') == true) {
      localStorage.setItem('rowData', '');
      window.location.reload();
    }
  };

  if (!field) {
    return (
      <th className={css.trashBtn} onClick={handleReset}>
        <img src={trash} />
      </th>
    );
  }

  return (
    <th className={css.th} onClick={handleInput}>
      {isInput ? (
        <input
          ref={inputRef}
          className={css.input}
          maxLength={3}
          minLength={3}
          autoFocus
          onBlur={handleBlur}
        />
      ) : (
        field
      )}
    </th>
  );
});

TableHeader.displayName = 'TableHeader';
